import { TextField, Typography } from '@material-ui/core'
import ApartmentOutlinedIcon from '@material-ui/icons/ApartmentOutlined'
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined'
import { Autocomplete } from '@material-ui/lab'

import { getTranslate, lang } from '../../localization'
import { DestinationOption } from '../../types/accommodationSubscribedToChannel'
import { SearchAvailabilityInput } from '../../types/searchAvailability'
import useStyles from './styles/index'

export interface DestinationAutoCompleteProps {
  options: DestinationOption[]
  setSearchAvailabilityInput?: React.Dispatch<
    React.SetStateAction<SearchAvailabilityInput>
  >
  searchAvailabilityInput: SearchAvailabilityInput
  loadingForAccommodation: boolean
}

export const DestinationAutoComplete: React.FC<
  DestinationAutoCompleteProps
> = ({
  options,
  setSearchAvailabilityInput,
  searchAvailabilityInput,
  loadingForAccommodation
}) => {
  const classes = useStyles({ lang })

  const optionFound = options.find((item) => {
    if (searchAvailabilityInput && searchAvailabilityInput.cityID) {
      return item.cityID === searchAvailabilityInput.cityID
    } else if (
      searchAvailabilityInput &&
      searchAvailabilityInput.propertyCode
    ) {
      return item.destinationCode === searchAvailabilityInput.propertyCode
    }
  })

  return (
    <div className={classes.root}>
      <Autocomplete
        disableClearable
        options={options}
        value={optionFound}
        renderOption={(option) => (
          <div
            className={classes.optionContainer}
            dir={lang === 'fa' ? 'rtl' : 'ltr'}>
            {option.isCity ? (
              <LocationOnOutlinedIcon className={classes.icon} />
            ) : (
              <ApartmentOutlinedIcon className={classes.icon} />
            )}
            <Typography variant="caption" className={classes.optionFont}>
              {option.destinationName}
            </Typography>
          </div>
        )}
        onChange={(event, newValue) => {
          if (newValue.isCity) {
            setSearchAvailabilityInput?.((prev) => ({
              ...prev,
              cityID: newValue.cityID,
              propertyCode: undefined
            }))
          } else if (newValue && newValue.destinationCode) {
            setSearchAvailabilityInput?.((prev) => ({
              ...prev,
              propertyCode: newValue.destinationCode!,
              cityID: undefined
            }))
          }
        }}
        groupBy={(option) =>
          option.isCity ? getTranslate('City') : getTranslate('Hotel')
        }
        getOptionLabel={(option) => option.destinationName}
        size="small"
        inputMode="search"
        classes={{
          endAdornment: classes.noEndAdornment,
          option: classes.rootTextfield,
          groupLabel: classes.groupLabel
        }}
        loading={loadingForAccommodation}
        loadingText={getTranslate('Loading') + '...'}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={getTranslate('Where is your destination?')}
            variant="outlined"
            className={classes.placeHolder}
            InputProps={{
              ...params.InputProps,
              classes: { notchedOutline: classes.noBorder }
            }}
          />
        )}
      />
    </div>
  )
}
